"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectionCaretUpFill = void 0;
var tslib_1 = require("tslib");
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
var react_1 = tslib_1.__importStar(require("react"));
var BaseIcon_1 = tslib_1.__importDefault(require("@ad/anq-iconfont.macro/lib/components/BaseIcon"));
var DirectionCaretUpFill = /** @class */ (function (_super) {
    tslib_1.__extends(DirectionCaretUpFill, _super);
    function DirectionCaretUpFill() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.iconSvg = function () { return (react_1.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 1024 1024", version: "1.1", fill: "currentColor", "aria-hidden": "true", focusable: "false" },
            react_1.default.createElement("path", { d: "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" }))); };
        return _this;
    }
    DirectionCaretUpFill.prototype.render = function () {
        return react_1.default.createElement(BaseIcon_1.default, tslib_1.__assign({ component: this.iconSvg }, this.props));
    };
    return DirectionCaretUpFill;
}(react_1.Component));
exports.DirectionCaretUpFill = DirectionCaretUpFill;
//# sourceMappingURL=DirectionCaretUpFill.js.map